import script from "./productTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./productTable.vue?vue&type=script&lang=ts&setup=true"

import "./productTable.vue?vue&type=style&index=0&id=53de9322&lang=scss"

const __exports__ = script;

export default __exports__